import { render, staticRenderFns } from "./historyText.vue?vue&type=template&id=1af43176&"
import script from "./historyText.vue?vue&type=script&lang=js&"
export * from "./historyText.vue?vue&type=script&lang=js&"
import style0 from "./common.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports